const _locationApis = {
    getLocationByParent: function (parentId) {
        return _axiosService.post(
            `/weblocation/GetLocationByParent/${parentId}`
        );
    },
};
